exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inner {\r\n    display: inline;\r\n    word-break: break-word;\r\n}\r\n\r\n.see-more-text {\r\n    font-size: 0.75rem !important;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/directive/post-text/post-text.component.css
// module id = ../../../../../src/app/directive/post-text/post-text.component.css
// module chunks = main